import { Injectable } from '@angular/core';
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";
import { WidgetCriteria } from "../../models/DataModels";
import * as _ from "lodash";


@Injectable()
export class PutwallstatusdashboardService extends BaseService {

  constructor( private _commonService: CommonService,
    private _widgetHelper: WidgethelperService) {    
    super();
  }

  colorCodes = [];
  init(widget: any) {
    this.colorCodes = this._commonService.getColorCodes();
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastPutWallOrderStatus").subscribe(
      (data: any) => {
        let result: Array<any> = [];
        result = data;
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        let criteria = widget.widgetsettings && widget.widgetsettings.Criteria ?
                      JSON.parse(widget.widgetsettings.Criteria) : new WidgetCriteria()   
        criteria.WaveStatusActive = criteria.WaveStatusActive ? criteria.WaveStatusActive : 'ACTIVE';
        switch(criteria.WaveStatusType){
          case "INDIVIDUAL PACK PUTWALL" :
            widget.Title = "Individual Pack Putwall Status - " + criteria.WaveStatusActive + " PUTWALL";       
          break;           
          default :
            widget.Title = "Individual Putwall Status - " + criteria.WaveStatusActive + " PUTWALL";    
          break;
        }

        if (result && result.length > 0) {
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId 
            && resultcreationtime == widget.widgetcreationtime && !widget.IfNoDataFound) {
          widget.dataLoaded = false;         
          widget.errorMessage = null;  
          
          //Filter data based on active / in active selection of putwall
          result = result.filter(x => {
            return  (x.PutwallActiveFlag &&
                x.PutwallActiveFlag.toLowerCase() == criteria.WaveStatusActive.toLowerCase());
          });

          if (result && result.length > 0) {          
            switch(criteria.WaveStatusType){
              case "INDIVIDUAL PACK PUTWALL" :              
                this.loadPackPutwallStatus(widget,result,criteria);
              break;           
              default :               
                this.loadPutwallStatus(widget,result); 
              break;
            }
          }
          else{
            widget.errorMessage = errorMessages.noWidgetData;
          }       
                
          this._commonService.lastUpdatedTime = lastUpdatedTime;
        }

        if (widget.IfNoDataFound) {
          widget.errorMessage = errorMessages.noWidgetData;
        }           

        widget.dataLoaded = true;
      },
      err => {       
        console.log("listenFor broadcastPutWallOrderStatus error", err);       
      }
    );

  }

  loadPutwallStatus(widget: any,result:any){
    widget.chartOptions = this.chartOptions();   
    
    let categoryList = [];    
    let status = [];
    let category = []; 
    let colors = [];

    //Sort result with wave number
    let sortedData = this._commonService.sortArray(result, 'PutWallName');

    for (let i = 0; i < sortedData.length; i++) {
      if (sortedData[i].Status && sortedData[i].Status != '' && status.indexOf(sortedData[i].Status) == -1) {
        status.push(sortedData[i].Status);
      }
      if (sortedData[i].PutWallName && sortedData[i].PutWallName != '' && categoryList.indexOf(sortedData[i].PutWallName) == -1)  {
        categoryList.push(sortedData[i].PutWallName);
        category.push(sortedData[i].PutWallName + (sortedData[i].PutWallDesc ? '\n' + sortedData[i].PutWallDesc : ''));
      }
    }    
    if(status.length == 0 ||  categoryList.length == 0 ){
      widget.errorMessage = errorMessages.noWidgetData;
      return;
    }
    
    status.forEach(s =>{
      let cartonQty = [];  
      let unitQty = [];  

      categoryList.forEach(c => {
        let itemFound = sortedData.filter(item => {
          return item.PutWallName == c && item.Status == s && item.GroupBy.toLowerCase() == "carton";
        });

        if(itemFound){
          if(itemFound.length > 0){
            let qty = 0;
            itemFound.forEach(q => {
              qty = qty + q.Quantity;
            });
            cartonQty.push({name:'Carton',value:qty});
          }          
        }
        else{
          cartonQty.push({name:'Carton',value:null});
        }      

        itemFound = sortedData.filter(item => {
          return item.PutWallName == c && item.Status == s && item.GroupBy.toLowerCase() == "unit";
        });

        if(itemFound){
          if(itemFound.length > 0){
            let qty = 0;
            itemFound.forEach(q => {
              qty = qty + q.Quantity;
            });
            unitQty.push({name:'Unit',value:qty});
          }          
        }
        else{
          unitQty.push({name:'Carton',value:null});
        } 
      });

      let color = this.colorCodes.find(x => {return x.status == s.toUpperCase()})
      if(color){
        colors.push(color.color)
      }
      this.addDataSeries(widget.chartOptions, cartonQty,s,'bar','a')   
      this.addDataSeries(widget.chartOptions, unitQty,s, 'bar','b')   
    });

    widget.chartOptions.color = colors;
    widget.chartOptions.xAxis.data = category;
    widget.chartOptions.grid.left = '6%';
    widget.chartOptions.grid.bottom = '6%';
    widget.chartOptions.xAxis.axisLabel.rotate = 45;
    widget.chartOptions.tooltip.formatter = this.tooltipNameValueFormater;
    if(category && category.length > 10)    {
      this.addZoomBarEnd(widget.chartOptions,0,30); 
    }
    else {
      this.addZoomBar(widget.chartOptions); 
    }
    if(widget.chartOptions.series && widget.chartOptions.series.length > 0){
      widget.chartOptions.series.forEach(s => {
        s.label = { show: true, position: 'inside'};
      });
    }
    
  }

  loadPackPutwallStatus(widget: any,result:any, criteria){
    if(!criteria || ! criteria.PutwallLkp){
      widget.errorMessage = errorMessages.noWidgetData;
      return;
    }

    let data = result.filter(x => { return x.PutWallName == criteria.PutwallLkp.value});
    if(!data || data.length == 0){
      widget.errorMessage = errorMessages.noWidgetData;
      return;
    }
    else{
      widget.chartOptions = this.chartOptions();    

      let status = [];
      let category = []; 
      let categoryList = []; 
      let colors = [];  

       //Sort result with wave number
      let sortedData = this._commonService.sortArray(data, 'Wave');

      for (let i = 0; i < sortedData.length; i++) {
        if (sortedData[i].Status != '' && status.indexOf(sortedData[i].Status) == -1) {
          status.push(sortedData[i].Status);
        }
        if (sortedData[i].PackWaveId && sortedData[i].PackWaveId != '' && categoryList.indexOf(sortedData[i].PackWaveId) == -1)  {
          categoryList.push(sortedData[i].PackWaveId);       
          category.push(sortedData[i].PackWaveId + (sortedData[i].Wave ? '\n' + 'Wave: ' + sortedData[i].Wave : ''));  
        }
      }    
      status.forEach(s =>{
        let cartonQty = [];  
        let unitQty = [];       

        categoryList.forEach(c => {
          let itemFound = sortedData.filter(item => {
            return item.PackWaveId == c && item.Status == s && item.GroupBy.toLowerCase() == "carton";
          });

          if(itemFound){
            if(itemFound.length > 0){
              let qty = 0;
              itemFound.forEach(q => {
                qty = qty + q.Quantity;
              });
              cartonQty.push({name:'Carton',value:qty});
            }          
          }
          else{
            cartonQty.push({name:'Carton',value:null});
          }      

          itemFound = sortedData.filter(item => {
            return item.PackWaveId == c && item.Status == s && item.GroupBy.toLowerCase() == "unit";
          });

          if(itemFound){
            if(itemFound.length > 0){
              let qty = 0;
              itemFound.forEach(q => {
                qty = qty + q.Quantity;
              });
              unitQty.push({name:'Unit',value:qty});
            }          
          }
          else{
            unitQty.push({name:'Unit',value:null});
          } 
        });

        let color = this.colorCodes.find(x => {return x.status == s.toUpperCase()})
        if(color){
          colors.push(color.color)
        }
        this.addDataSeries(widget.chartOptions, cartonQty,s, 'bar','a')   
        this.addDataSeries(widget.chartOptions, unitQty,s, 'bar','b')   
      });

      widget.chartOptions.color = colors;
      widget.chartOptions.xAxis.data = category;
      widget.chartOptions.grid.left = '6%';
      widget.chartOptions.grid.bottom = '6%';
      widget.chartOptions.xAxis.axisLabel.rotate = 45;
      widget.chartOptions.tooltip.formatter = this.tooltipNameValueFormater;
      if(category && category.length > 10)    {
        this.addZoomBarEnd(widget.chartOptions,0,30); 
      }
      else {
        this.addZoomBar(widget.chartOptions); 
      }
      if(widget.chartOptions.series && widget.chartOptions.series.length > 0){
        widget.chartOptions.series.forEach(s => {
          s.label = { show: true, position: 'inside'};
        });
      }
      widget.chartOptions.title = [{
          subtext:  'Putwall: ' + criteria.PutwallLkp.label,
          //left: '1%',
          top: '-2%',
          textAlign: 'left',
          subtextStyle:{fontSize:'12',fontWeight:'bold'}
      }];
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/services/widgets/putwallstatusdashboard.service.ts